<div class="row justify-content-center align-items-center" mat-dialog-title>
  <div class="col-md-10 col-10">
    <h5 class="text-left txt-primario">Estimación - {{this.siniestro}}</h5>
  </div>
  <div class="col-md-2 col-2 text-right">
    <i (click)="closeDialog('Cancelar')" class="fas fa-times icon-close"></i>
  </div>
</div>

<mat-dialog-content class="py-0">
  @if (listCoberturas.data?.length) {
    <app-detalle-tabla-coberturas-siniestro-resumen [listCoberturas]="listCoberturas"
      [estimaciones]="estimacionesSiniestro" [ocultarCoberturasAsegurado]="false" [ocultarCoberturasTercero]="true"
      >
    </app-detalle-tabla-coberturas-siniestro-resumen>
  } @else {
    <div class="row">
      <div class="col-md-12">
        <small>No se encontraron coberturas</small>
      </div>
    </div>
  }
</mat-dialog-content>
@if (listCoberturas.data?.length) {
  <mat-dialog-actions class="row mx-0 justify-content-md-end">
    <div class="col-md-auto col-auto">
      <button type="submit" color="accent" class="mx-1 my-1" mat-raised-button (click)="closeDialog('Cancelar')">
        Cancelar
      </button>
    </div>
  </mat-dialog-actions>
}